import { IDebtState } from "./types.ts";
import { axiosInstance } from "../axiosConfig.ts";

const basePath = "/v1/debt-state";

export const debtAPI = {
  getDebtState: async (): Promise<IDebtState> => {
    const response = await axiosInstance.get<IDebtState>(basePath);
    return response.data;
  },
};
